module.exports = __webpack_public_path__ + "img/hsbc-background.fc91b004.jpg";